import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../../usercontext'
import { getIdData } from '../../../lib/profiles'
import { updateCompanyLogo, uploadCompanyLogo, getCompanyLogo } from '../../../lib/company'

export default function AdminProfile() {
	const [selectedCompanyLogo, setSelectedCompanyLogo] = useState(null)
	const [adminInfo, setAdminInfo] = useState()
	const { profile } = useAuth()
	const [companyLogo, setCompanyLogo] = useState('/defaultlogo.png')
	const navigate = useNavigate()

	const timestamp = new Date().getTime()

	console.log('profile:', profile);
	

	async function handleCompanyLogoChange() {
		if (!selectedCompanyLogo) {
			alert('Please select a logo first')
			return
		}

		if (!profile || !profile.companyId) {
			alert('Company information not available')
			return
		}

		// Validate image dimensions
		const img = new Image()
		img.src = URL.createObjectURL(selectedCompanyLogo)
		await new Promise((resolve) => (img.onload = resolve))

		if (img.width === img.height) {
			alert('Please upload a rectangle image for the company logo')
			return
		}

		if (img.width > 800 || img.height > 800) {
			alert('Image dimensions should not exceed 800x800 pixels')
			return
		}

		try {
			const fileExt = selectedCompanyLogo.name.split('.').pop()
			const fileName = `company_${profile.companyId}_${timestamp}.${fileExt}`

			await uploadCompanyLogo(fileName, selectedCompanyLogo)
			await updateCompanyLogo(profile.companyId, fileName)

			// Get the new logo
			const newLogoUrl = await getCompanyLogo(profile.companyId)
			setCompanyLogo(newLogoUrl)
			setSelectedCompanyLogo(null)

			// Dispatch a custom event to notify other components
			const event = new CustomEvent('logoUpdated', { detail: { logoUrl: newLogoUrl } })
			window.dispatchEvent(event)
		} catch (error) {
			alert('Failed to update company logo')
			console.error('Error updating logo:', error)
		}
	}

	async function GetData() {
		try {
			if (!profile) {
				console.warn('Profile not available yet')
				return
			}

			if (!profile.companyId) {
				console.warn('Company ID not available')
				return
			}

			// Get admin info
			const info = await getIdData(profile.id)
			setAdminInfo(info)

			// Get company logo
			const logoUrl = await getCompanyLogo(profile.companyId)
			setCompanyLogo(logoUrl)
		} catch (error) {
			console.error('Error in GetData:', error)
		}
	}

	useEffect(() => {
		if (profile && profile.companyId) {
			GetData()
		}
	}, [profile, profile?.companyId])

	const companyLogoSection = (
		<div className="course-group mb-4 d-flex">
			<div className="d-flex align-items-center">
				<div>
					{selectedCompanyLogo ? (
						<img src={URL.createObjectURL(selectedCompanyLogo)} alt="Company Logo" className="img-fluid" style={{ maxWidth: '200px' }} />
					) : (
						<img
							src={companyLogo}
							alt="Company Logo"
							className="img-fluid"
							style={{
								maxWidth: '200px',
								opacity: '1',
								transition: 'opacity 0.3s ease-in-out'
							}}
							onError={(e) => (e.target.src = '/defaultlogo.png')}
						/>
					)}
				</div>
				<div className="course-name ms-3">
					<h4>Your Company Logo</h4>
					<p>
						Please upload a rectangle image
						<br />
						Maximum size: 800x800 pixels
					</p>
				</div>
			</div>
			<div className="profile-share d-flex align-items-center justify-content-center">
				<div className="relative-form">
					<label className="relative-file-upload btn btn-secondary">
						Select Logo
						<input type="file" accept="image/*" onChange={(e) => setSelectedCompanyLogo(e.target.files[0])} style={{ display: 'none' }} />
					</label>
				</div>
				{selectedCompanyLogo && (
					<button onClick={handleCompanyLogoChange} className="btn btn-success ms-2">
						Update Logo
					</button>
				)}
			</div>
		</div>
	)

	return (
		<div className="col-xl-9 col-md-8 mx-auto">
			<div className="settings-widget profile-details">
				<div className="settings-menu p-0">
					<div className="profile-heading">
						<h3>Profile Details</h3>
						<p>You have full control to manage your own account setting.</p>
					</div>

					{companyLogoSection}

					<div className="settings-widget">
						<div className="settings-inner-blk p-0">
							<div className="checkout-form personal-address add-course-info">
								<div className="personal-info-head">
									<h4>Admin Details</h4>
								</div>
								<form action="#">
									<div className="row">
										<div className="col-lg-6">
											<div className="form-group">
												<label className="form-control-label">Name</label>
												<p>{adminInfo ? adminInfo[0].name : ''}</p>
											</div>
										</div>
										<div className="col-lg-6">
											<div className="form-group">
												<label className="form-control-label">Surname</label>
												<p>{adminInfo ? adminInfo[0].surname : ''}</p>
											</div>
										</div>
										<div className="col-lg-6">
											<div className="form-group">
												<label className="form-control-label">Phone</label>
												<p>{adminInfo ? adminInfo[0].phone : ''}</p>
											</div>
										</div>
										<div className="col-lg-6">
											<div className="form-group">
												<label className="form-control-label">Email</label>
												<p>{adminInfo ? adminInfo[0].email : ''}</p>
											</div>
										</div>
										<div className="update-profile d-flex justify-content-between">
											<button type="button" className="btn btn-primary" onClick={() => navigate(`/admin/admin-profile-edit`)}>
												Update Profile
											</button>

											<Link to="/admin/newpassword" className="btn btn-warning">
												Change Password
											</Link>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
